
import _ from 'lodash';
import React, { useEffect } from 'react';
import tippy from 'tippy.js';
import PropTypes from 'prop-types';

const ButtonTooltip = ({ className, content, theme }) => {
    if (!className) throw new Error("Button Tooltip className undefined");

    const uniqueId = _.uniqueId("tooltip-button-");

    useEffect(() => {
        // Enable tooltip.
        tippy(document.querySelectorAll(`#${uniqueId}`), {
            interactive: true,
            allowHTML: true,
            placement: theme === 'bentley' ? 'bottom-start' : 'bottom',
            theme: theme || "default",
            arrow: true,
        });
    });

    return <span className="tooltip-container u-mb-small u-pl-xsmall">
        <button
            id={uniqueId}
            className={`${className} js-tooltip c-tooltip tooltip-icon u-mh-xsmall`}
            data-tippy-content={content}
        >
            i
        </button>
        <style>
            {`
                .tippy-box p {
                    font-size: 14px !important;
                    color: rgb(0, 0, 0) !important;
                }

                .tippy-box[data-theme~='bentley'] .tippy-content {
                    background-color: #DDDDDD;
                    width: 772px;
                    padding: 16px;
                    line-height: 24px;
                    transform: translateX(-60px);
                }

                .tippy-box[data-theme~='bentley'] a {
                    color: rgb(0, 102, 204) !important;
                    background: transparent !important;
                }

                .tippy-box[data-theme~='bentley'] .tippy-arrow::before {
                    border-bottom: 10px solid #DDDDDD;
                }
            `}
        </style>
    </span>
}

ButtonTooltip.propTypes = {
    className: PropTypes.string,
    content: PropTypes.string,
    theme: PropTypes.string,
};

export default ButtonTooltip;